import { useEffect, useRef, useState } from "react";
import "@/App.css";
import { motion, useScroll, useTransform } from "framer-motion";
import Lenis from "@studio-freight/lenis";
import React from "react";
import { 
  BarChart3, 
  Bot, 
  Clapperboard, 
  Target, 
  Workflow, 
  LineChart, 
  TrendingUp,
  MessageSquare,
  Users,
  LayoutDashboard,
  Sparkles,
  Film,
  Video,
  Camera,
  BookOpen,
  Building2,
  MapPin,
  MessageCircle,
  Mail,
  ChevronDown,
  Instagram
} from "lucide-react";

// Instagram Link - Fixed
const INSTAGRAM_LINK = "https://instagram.com/fxr.mkt";

// Email
const EMAIL = "ribadeneira79@gmail.com";

// Assets
const FXR_LOGO = "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/fvutpeyz_ChatGPT%20Image%20Feb%2024%2C%202026%2C%2012_08_23%20PM.png";

// Official Partners
const WESPEAK_LOGO = "https://customer-assets.emergentagent.com/job_0e1ba4ee-a725-40b4-9962-4ddff85eb22c/artifacts/40w3b11k_Imagotipo%20arriba%20%282%29.png";
const TALKBASE_LOGO = "https://customer-assets.emergentagent.com/job_0e1ba4ee-a725-40b4-9962-4ddff85eb22c/artifacts/gx2myitt_573456277_17846858283597194_8540560003170546714_n-removebg-preview.png";

// Integration Logos
const INTEGRATION_LOGOS = [
  { name: "ClickUp", url: "https://customer-assets.emergentagent.com/job_0e1ba4ee-a725-40b4-9962-4ddff85eb22c/artifacts/gwvwzacq_ClickUp-Logo-tumb.png" },
  { name: "ManyChat", url: "https://customer-assets.emergentagent.com/job_0e1ba4ee-a725-40b4-9962-4ddff85eb22c/artifacts/xxrj2ekc_cSQBl8uiVYxPULuoo08xLgnq8I-removebg-preview.png" },
  { name: "Repurpose.io", url: "https://customer-assets.emergentagent.com/job_0e1ba4ee-a725-40b4-9962-4ddff85eb22c/artifacts/ona75qsl_Main-Repurpose-Logo-no-space-around-1024x176.webp" },
  { name: "Notion", url: "https://customer-assets.emergentagent.com/job_0e1ba4ee-a725-40b4-9962-4ddff85eb22c/artifacts/d8yixw59_notion-logo-png_seeklogo-425508.png" },
  { name: "HeyGen", url: "https://customer-assets.emergentagent.com/job_0e1ba4ee-a725-40b4-9962-4ddff85eb22c/artifacts/49w8xs8y_Heygen-Image-removebg-preview.png" },
  { name: "Bricks.ai", url: "https://customer-assets.emergentagent.com/job_0e1ba4ee-a725-40b4-9962-4ddff85eb22c/artifacts/5qyk71oy_Bricks.ai-logo-170221.png" },
  { name: "Emergent", url: "https://customer-assets.emergentagent.com/job_0e1ba4ee-a725-40b4-9962-4ddff85eb22c/artifacts/6x6z0kjk_emergent-ai-logo-removebg-preview.png" },
  { name: "Shopify", url: "https://customer-assets.emergentagent.com/job_0e1ba4ee-a725-40b4-9962-4ddff85eb22c/artifacts/7vwdsoll_high-resolution-shopify-official-logo-11764782319wfjvemra5r-removebg-preview.png" }
];

// Translations
const translations = {
  es: {
    nav: { services: "Servicios", portfolio: "Portafolio", presence: "Presencia", team: "Nosotros", contact: "Contactar" },
    hero: { 
      badge: "Performance Marketing Agency",
      subtitle: "+7 años construyendo sistemas de crecimiento digital en",
      cta1: "Escalar mi marca",
      cta2: "Ver portafolio"
    },
    authority: { title: "años de experiencia", description: "Durante más de siete años hemos trabajado con marcas en distintos sectores, desarrollando sistemas de adquisición, posicionamiento y producción audiovisual profesional con enfoque en", highlight: "resultados medibles" },
    pillars: { title: "Los 3 Pilares", subtitle: "La metodología que impulsa resultados" },
    results: { title: "Resultados Reales", subtitle: "Casos de éxito con métricas verificables" },
    services: { title: "Servicios que transforman marcas", subtitle: "Soluciones integrales para tu crecimiento" },
    portfolio: { title: "Nuestro Portafolio", subtitle: "Producciones que cuentan historias" },
    photography: { title: "Fotografía Profesional", subtitle: "Imágenes que capturan la esencia de tu marca" },
    brands: { title: "Marcas que confían en FXR", subtitle: "Clientes que han crecido con nosotros" },
    integrations: { title: "Integraciones", subtitle: "Herramientas que potencian nuestros flujos" },
    partners: { title: "Official Partners", subtitle: "Alianzas estratégicas de alto nivel", badge: "Partner Oficial" },
    presence: { title: "Presencia Internacional" },
    team: { title: "Nosotros", subtitle: "El equipo detrás de FXR Marketing", members: {
      ceo: "Chief Executive Officer",
      production: "Head of Production",
      accountManager: "Account Manager",
      productionAssistant: "Production Assistant",
      accountExecutive: "Account Executive"
    } },
    differentiator: { title: "No solo creamos contenido.", subtitle: "Diseñamos estrategias de crecimiento con resultados medibles." },
    contact: { 
      title: "Construyamos algo", 
      highlight: "poderoso",
      whatsapp: "WhatsApp",
      instagram: "Síguenos en Instagram",
      email: "Enviar correo",
      formTitle: "Solicita una cotización",
      formSubtitle: "Cuéntanos sobre tu proyecto",
      name: "Nombre completo",
      emailLabel: "Correo electrónico",
      phone: "Teléfono",
      company: "Empresa",
      service: "Servicio de interés",
      services: {
        digital: "Pauta Digital",
        audiovisual: "Producción Audiovisual",
        social: "Manejo Integral de Redes",
        consulting: "Consultoría"
      },
      message: "Mensaje",
      submit: "Enviar solicitud",
      budget: "Presupuesto estimado"
    },
    footer: { tagline: "Agencia de Performance Marketing, Producción Audiovisual e Integraciones de IA" }
  },
  en: {
    nav: { services: "Services", portfolio: "Portfolio", presence: "Presence", team: "Team", contact: "Contact" },
    hero: { 
      badge: "Performance Marketing Agency",
      subtitle: "+7 years building digital growth systems in",
      cta1: "Scale my brand",
      cta2: "View portfolio"
    },
    authority: { title: "years of experience", description: "For over seven years we have worked with brands in different sectors, developing acquisition systems, positioning and professional audiovisual production focused on", highlight: "measurable results" },
    pillars: { title: "The 3 Pillars", subtitle: "The methodology that drives results" },
    results: { title: "Real Results", subtitle: "Success stories with verifiable metrics" },
    services: { title: "Services that transform brands", subtitle: "Comprehensive solutions for your growth" },
    portfolio: { title: "Our Portfolio", subtitle: "Productions that tell stories" },
    photography: { title: "Professional Photography", subtitle: "Images that capture your brand's essence" },
    brands: { title: "Brands that trust FXR", subtitle: "Clients who have grown with us" },
    integrations: { title: "Integrations", subtitle: "Tools that power our workflows" },
    partners: { title: "Official Partners", subtitle: "High-level strategic alliances", badge: "Official Partner" },
    presence: { title: "International Presence" },
    team: { title: "About Us", subtitle: "The team behind FXR Marketing", members: {
      ceo: "Chief Executive Officer",
      production: "Head of Production",
      accountManager: "Account Manager",
      productionAssistant: "Production Assistant",
      accountExecutive: "Account Executive"
    } },
    differentiator: { title: "We don't just create content.", subtitle: "We design growth strategies with measurable results." },
    contact: { 
      title: "Let's build something", 
      highlight: "powerful",
      whatsapp: "WhatsApp",
      instagram: "Follow us on Instagram",
      email: "Send email",
      formTitle: "Request a quote",
      formSubtitle: "Tell us about your project",
      name: "Full name",
      emailLabel: "Email address",
      phone: "Phone",
      company: "Company",
      service: "Service of interest",
      services: {
        digital: "Digital Advertising",
        audiovisual: "Audiovisual Production",
        social: "Full Social Media Management",
        consulting: "Consulting"
      },
      message: "Message",
      submit: "Submit request",
      budget: "Estimated budget"
    },
    footer: { tagline: "Performance Marketing Agency, Audiovisual Production & AI Integrations" }
  }
};

// Language Context
const LanguageContext = React.createContext();

const useLanguage = () => React.useContext(LanguageContext);

const CLIENT_LOGOS = [
  { name: "Subway", url: "https://customer-assets.emergentagent.com/job_0e1ba4ee-a725-40b4-9962-4ddff85eb22c/artifacts/f9jx3gqb_Subway.logo.8.5.svg.png" },
  { name: "COCO House", url: "https://customer-assets-lqy194kg.emergentagent.net/job_0e1ba4ee-a725-40b4-9962-4ddff85eb22c/artifacts/aab030a91a595811_Captura%20de%20Pantalla%202026-10-08%20a%20la%28s%29%2014.07.15.png" },
  { name: "Invexa", url: "https://customer-assets-lqy194kg.emergentagent.net/job_0e1ba4ee-a725-40b4-9962-4ddff85eb22c/artifacts/c125408ca4830dd0_Captura%20de%20Pantalla%202026-10-08%20a%20la%28s%29%2014.07.20.png" },
  { name: "BIO Balanceados Equinos", url: "https://customer-assets-lqy194kg.emergentagent.net/job_0e1ba4ee-a725-40b4-9962-4ddff85eb22c/artifacts/86338870a9f51b52_Captura%20de%20Pantalla%202026-10-08%20a%20la%28s%29%2014.07.25.png" },
  { name: "LUM", url: "https://customer-assets.emergentagent.com/job_0e1ba4ee-a725-40b4-9962-4ddff85eb22c/artifacts/8yd476it_Captura%20de%20Pantalla%202026-03-09%20a%20la%28s%29%2013.50.30.png" },
  { name: "Maimará", url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/458js098_80056439_616269972511732_1326079798409166848_n.jpg" },
  { name: "Probe Motor", url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/bw79zg76_118559441_324946412197122_1453936336854861843_n.jpg" },
  { name: "Materia", url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/sl01os5e_155585210_184944123058184_5122795603715655434_n.jpg" },
  { name: "U Brand", url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/9vtjay64_191690304_253139596592355_710650041870802609_n.jpg" },
  { name: "China Blanca", url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/dn0e5b65_340728457_598405812208175_5323979624134916098_n.jpg" },
  { name: "Gentle Drop", url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/d8mfef0q_372132464_6549806261767632_2084745163512305839_n.jpg" },
  { name: "Bear's Head", url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/uxlb3ktg_431036764_733687642202397_8568106320924636650_n.jpg" },
  { name: "U Verde", url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/t1v2sbhc_456563876_1728868921294340_7667330459731805351_n.jpg" },
  { name: "Terrocal", url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/ru1327tb_491426708_17917642965089931_5997410154619449153_n.jpg" },
  { name: "Crom", url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/vdndiikh_498619083_17846771550476196_7978313550129731541_n.jpg" },
  { name: "Dika Boxing", url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/cci24ov9_630003234_17853174012666345_7378436022140108478_n.jpg" },
  { name: "Top Motors", url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/vfov6ri3_Captura%20de%20Pantalla%202026-02-24%20a%20la%28s%29%2018.02.32.png" },
  { name: "Virtual Latinos", url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/tfzonjsu_Captura%20de%20Pantalla%202026-02-24%20a%20la%28s%29%2018.02.35.png" },
  { name: "Termas La Merced", url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/patkj8n6_Captura%20de%20Pantalla%202026-02-24%20a%20la%28s%29%2018.02.38.png" },
  { name: "Hacienda Cochauco", url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/t5jx1amo_Captura%20de%20Pantalla%202026-02-24%20a%20la%28s%29%2018.02.41.png" },
  { name: "ANKU", url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/9wyvmxch_Logo%20firma%20de%20abogados%20moderno%20ilustrativo%20blanco%20con%20negro%20.png" },
  { name: "SXE Motors", url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/diz0vvqj_images%20%281%29.jpeg" },
  { name: "Anku Light", url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/5i77fcfk_Captura%20de%20Pantalla%202026-02-24%20a%20la%28s%29%2018.02.44.png" },
  { name: "Arcontec", url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/w8rm1gfl_Captura%20de%20Pantalla%202026-02-24%20a%20la%28s%29%2018.02.47.png" }
];

const WHATSAPP_NUMBER = "+593989803884";
const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER.replace(/[^0-9]/g, '')}`;

// Fade up animation variants
const fadeUpVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] }
  }
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.1 }
  }
};

// Video Thumbnail - AutoPlay all at once
const VideoThumbnail = ({ video }) => {
  return (
    <div
      className="relative rounded-xl overflow-hidden group"
      data-testid={`video-item-${video.id}`}
    >
      <div className="relative aspect-[9/16] bg-[#1a1a1a]">
        <video
          src={video.url}
          className="w-full h-full object-cover"
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent pointer-events-none" />
        <div className="absolute bottom-0 left-0 right-0 p-3 pointer-events-none">
          <span className="font-space text-[10px] uppercase tracking-widest text-cyan-400 mb-1 block">
            {video.category}
          </span>
          <h3 className="font-syne font-bold text-xs md:text-sm text-white line-clamp-2">
            {video.title}
          </h3>
        </div>
      </div>
    </div>
  );
};

// Main Video Player - AutoPlay
const MainVideoPlayer = ({ video }) => {
  return (
    <div className="mb-8">
      <div className="relative rounded-2xl overflow-hidden aspect-video bg-[#1a1a1a] group">
        <video
          src={video.url}
          className="w-full h-full object-cover"
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent pointer-events-none" />
        <div className="absolute bottom-0 left-0 right-0 p-4 md:p-8 pointer-events-none">
          <span className="font-space text-xs md:text-sm uppercase tracking-widest text-cyan-400 mb-2 block">
            {video.category}
          </span>
          <h3 className="font-syne font-bold text-xl md:text-2xl lg:text-3xl text-white">
            {video.title}
          </h3>
        </div>
      </div>
    </div>
  );
};

// Navigation Component
const Navigation = () => {
  const { lang, setLang, t } = useLanguage();
  
  return (
    <motion.nav 
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2 }}
      className="fixed top-0 left-0 right-0 z-50"
    >
      <div className="bg-white shadow-lg">
        <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between">
          <a href="#hero" className="flex items-center" data-testid="nav-logo">
            <img src={FXR_LOGO} alt="FXR Marketing" className="h-20 md:h-28 w-auto object-contain" />
          </a>
          <div className="hidden md:flex items-center gap-8">
            <a href="#pilares" className="text-gray-700 hover:text-gray-900 transition-colors font-space text-sm" data-testid="nav-pilares">{t.nav.services}</a>
            <a href="#videos" className="text-gray-700 hover:text-gray-900 transition-colors font-space text-sm" data-testid="nav-portafolio">{t.nav.portfolio}</a>
            <a href="#presencia" className="text-gray-700 hover:text-gray-900 transition-colors font-space text-sm" data-testid="nav-presencia">{t.nav.presence}</a>
            <a href="#nosotros" className="text-gray-700 hover:text-gray-900 transition-colors font-space text-sm" data-testid="nav-nosotros">{t.nav.team}</a>
            <a href="#contacto" className="bg-[#050505] text-white px-6 py-2 rounded-full font-space text-sm hover:bg-gray-800 transition-colors" data-testid="nav-contacto">{t.nav.contact}</a>
            {/* Language Selector */}
            <div className="flex items-center gap-1 border border-gray-200 rounded-full p-1">
              <button 
                onClick={() => setLang('es')}
                className={`px-3 py-1 rounded-full text-xs font-space transition-all ${lang === 'es' ? 'bg-black text-white' : 'text-gray-500 hover:text-gray-900'}`}
              >
                ES
              </button>
              <button 
                onClick={() => setLang('en')}
                className={`px-3 py-1 rounded-full text-xs font-space transition-all ${lang === 'en' ? 'bg-black text-white' : 'text-gray-500 hover:text-gray-900'}`}
              >
                EN
              </button>
            </div>
          </div>
          {/* Mobile Language Selector */}
          <div className="md:hidden flex items-center gap-1 border border-gray-200 rounded-full p-1">
            <button 
              onClick={() => setLang('es')}
              className={`px-2 py-1 rounded-full text-xs font-space transition-all ${lang === 'es' ? 'bg-black text-white' : 'text-gray-500'}`}
            >
              ES
            </button>
            <button 
              onClick={() => setLang('en')}
              className={`px-2 py-1 rounded-full text-xs font-space transition-all ${lang === 'en' ? 'bg-black text-white' : 'text-gray-500'}`}
            >
              EN
            </button>
          </div>
        </div>
      </div>
    </motion.nav>
  );
};

// Hero Section - fully translated
const HeroSection = () => {
  const { lang, t } = useLanguage();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end start"]
  });
  
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "30%"]);
  const opacity = useTransform(scrollYProgress, [0, 0.5], [1, 0]);

  // Rotating words animation - bilingual
  const [wordIndex, setWordIndex] = React.useState(0);
  const rotatingWordsES = ["Cinematic Growth", "Presencia Digital", "Posicionamiento", "Automatización", "Growth Marketing", "Estrategia"];
  const rotatingWordsEN = ["Cinematic Growth", "Digital Presence", "Positioning", "Automation", "Growth Marketing", "Strategy"];
  const rotatingWords = lang === 'es' ? rotatingWordsES : rotatingWordsEN;
  
  React.useEffect(() => {
    const interval = setInterval(() => {
      setWordIndex((prev) => (prev + 1) % rotatingWords.length);
    }, 2500);
    return () => clearInterval(interval);
  }, [rotatingWords.length]);

  return (
    <section id="hero" ref={ref} className="relative min-h-screen flex items-center justify-center overflow-hidden pt-28 bg-white" data-testid="hero-section">
      {/* Subtle grid background */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: `linear-gradient(rgba(0,0,0,0.1) 1px, transparent 1px),
                          linear-gradient(90deg, rgba(0,0,0,0.1) 1px, transparent 1px)`,
        backgroundSize: '80px 80px'
      }} />
      
      <motion.div 
        style={{ y, opacity }}
        className="relative z-10 text-center px-6 max-w-5xl mx-auto"
      >
        <motion.div
          variants={staggerContainer}
          initial="hidden"
          animate="visible"
          className="space-y-10"
        >
          {/* Agency tagline - minimal pill style */}
          <motion.div
            variants={fadeUpVariants}
            className="flex items-center justify-center"
          >
            <div className="inline-flex items-center gap-3 px-6 py-3 rounded-full border border-black/10 bg-black/[0.02]">
              <span className="w-2 h-2 rounded-full bg-cyan-500 animate-pulse" />
              <span className="font-space text-xs md:text-sm text-black/60 tracking-[0.1em] uppercase">
                {t.hero.badge}
              </span>
            </div>
          </motion.div>
          
          <motion.h1 
            variants={fadeUpVariants}
            className="font-inter font-semibold text-5xl sm:text-6xl md:text-7xl lg:text-8xl tracking-tight leading-[1.1] text-black"
            data-testid="hero-title"
          >
            <span>Data.</span>{" "}
            <span className="text-cyan-500">I</span><span className="text-emerald-500">A</span><span>.</span>
            <br />
            <motion.span
              key={wordIndex}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -30 }}
              transition={{ duration: 0.5, ease: "easeOut" }}
              className="text-gradient-cinematic inline-block"
            >
              {rotatingWords[wordIndex]}.
            </motion.span>
          </motion.h1>
          
          <motion.p 
            variants={fadeUpVariants}
            className="font-manrope text-base md:text-lg text-black/50 max-w-xl mx-auto leading-relaxed"
            data-testid="hero-subtitle"
          >
            {t.hero.subtitle}{" "}
            <span className="text-black/70">Ecuador</span>,{" "}
            <span className="text-black/70">USA</span>,{" "}
            <span className="text-black/70">México</span> {lang === 'es' ? 'y' : '&'}{" "}
            <span className="text-black/70">{lang === 'es' ? 'España' : 'Spain'}</span>
          </motion.p>
          
          <motion.div 
            variants={fadeUpVariants}
            className="flex flex-col sm:flex-row gap-4 justify-center pt-4"
          >
            <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="group inline-flex items-center justify-center gap-2 bg-black text-white px-8 py-3.5 rounded-full font-space text-sm tracking-wide hover:bg-black/80 transition-all" data-testid="hero-cta-escalar">
              {t.hero.cta1}
              <span className="group-hover:translate-x-1 transition-transform">→</span>
            </a>
            <a href="#videos" className="inline-flex items-center justify-center gap-2 border border-black/20 text-black/70 px-8 py-3.5 rounded-full font-space text-sm tracking-wide hover:bg-black/5 hover:text-black transition-all" data-testid="hero-cta-proyectos">
              {t.hero.cta2}
            </a>
          </motion.div>
        </motion.div>
        
        {/* Scroll indicator */}
        <motion.div 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.5 }}
          className="absolute bottom-12 left-1/2 -translate-x-1/2"
        >
          <motion.div
            animate={{ y: [0, 8, 0] }}
            transition={{ duration: 2, repeat: Infinity }}
            className="flex flex-col items-center gap-2"
          >
            <span className="font-space text-[10px] text-black/30 tracking-widest uppercase">Scroll</span>
            <div className="w-px h-8 bg-gradient-to-b from-black/20 to-transparent" />
          </motion.div>
        </motion.div>
      </motion.div>
    </section>
  );
};

// Authority Section
const AuthoritySection = () => {
  const { t } = useLanguage();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"]
  });
  
  const yParallax = useTransform(scrollYProgress, [0, 1], ["100px", "-100px"]);

  return (
    <section id="autoridad" ref={ref} className="relative py-32 md:py-48 overflow-hidden" data-testid="authority-section">
      {/* Giant 7 with parallax */}
      <motion.div 
        style={{ y: yParallax }}
        className="absolute inset-0 flex items-center justify-center pointer-events-none"
      >
        <span className="font-syne font-extrabold text-[300px] sm:text-[400px] md:text-[500px] lg:text-[600px] text-white/[0.02] leading-none select-none">
          7
        </span>
      </motion.div>
      
      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="font-syne font-bold text-4xl sm:text-5xl md:text-6xl mb-8" data-testid="authority-title">
            <span className="text-gradient-cinematic">+7</span> {t.authority.title}
          </h2>
          <p className="font-manrope text-lg md:text-xl text-white/60 leading-relaxed max-w-3xl mx-auto">
            {t.authority.description} <span className="text-white">{t.authority.highlight}</span>.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

// Pillars Section
const PillarsSection = () => {
  const { lang, t } = useLanguage();
  
  const pillarsES = [
    {
      id: "data",
      icon: <BarChart3 className="w-8 h-8" />,
      title: "DATA",
      description: "Medimos, analizamos y optimizamos cada decisión.",
      features: [
        { icon: <Target className="w-5 h-5" />, text: "Meta Ads" },
        { icon: <Workflow className="w-5 h-5" />, text: "Embudos" },
        { icon: <LineChart className="w-5 h-5" />, text: "Métricas avanzadas" },
        { icon: <TrendingUp className="w-5 h-5" />, text: "Escalamiento progresivo" }
      ],
      colorClass: "pillar-data",
      accentColor: "text-blue-400",
      glowColor: "group-hover:shadow-blue-500/20"
    },
    {
      id: "ia",
      icon: <Bot className="w-8 h-8" />,
      title: "IA",
      description: "Automatizamos procesos para aumentar eficiencia y conversión.",
      features: [
        { icon: <MessageSquare className="w-5 h-5" />, text: "Chatbots inteligentes" },
        { icon: <Users className="w-5 h-5" />, text: "Seguimiento automático de leads" },
        { icon: <LayoutDashboard className="w-5 h-5" />, text: "Integraciones CRM" },
        { icon: <Sparkles className="w-5 h-5" />, text: "Generación de copies con IA" }
      ],
      colorClass: "pillar-ia",
      accentColor: "text-violet-400",
      glowColor: "group-hover:shadow-violet-500/20"
    },
    {
      id: "cinematic",
      icon: <Clapperboard className="w-8 h-8" />,
      title: "CINEMATIC GROWTH",
      description: "Producción visual con estándar internacional.",
      features: [
        { icon: <Film className="w-5 h-5" />, text: "Reels optimizados para pauta" },
        { icon: <Video className="w-5 h-5" />, text: "Producción deportiva profesional" },
        { icon: <BookOpen className="w-5 h-5" />, text: "Documentales tipo storytelling" },
        { icon: <Building2 className="w-5 h-5" />, text: "Video corporativo" },
        { icon: <Camera className="w-5 h-5" />, text: "Fotografía profesional" }
      ],
      colorClass: "pillar-cinematic",
      accentColor: "text-cyan-400",
      glowColor: "group-hover:shadow-rose-500/20"
    }
  ];
  
  const pillarsEN = [
    {
      id: "data",
      icon: <BarChart3 className="w-8 h-8" />,
      title: "DATA",
      description: "We measure, analyze and optimize every decision.",
      features: [
        { icon: <Target className="w-5 h-5" />, text: "Meta Ads" },
        { icon: <Workflow className="w-5 h-5" />, text: "Funnels" },
        { icon: <LineChart className="w-5 h-5" />, text: "Advanced metrics" },
        { icon: <TrendingUp className="w-5 h-5" />, text: "Progressive scaling" }
      ],
      colorClass: "pillar-data",
      accentColor: "text-blue-400",
      glowColor: "group-hover:shadow-blue-500/20"
    },
    {
      id: "ia",
      icon: <Bot className="w-8 h-8" />,
      title: "AI",
      description: "We automate processes to increase efficiency and conversion.",
      features: [
        { icon: <MessageSquare className="w-5 h-5" />, text: "Smart chatbots" },
        { icon: <Users className="w-5 h-5" />, text: "Automated lead follow-up" },
        { icon: <LayoutDashboard className="w-5 h-5" />, text: "CRM integrations" },
        { icon: <Sparkles className="w-5 h-5" />, text: "AI-powered copywriting" }
      ],
      colorClass: "pillar-ia",
      accentColor: "text-violet-400",
      glowColor: "group-hover:shadow-violet-500/20"
    },
    {
      id: "cinematic",
      icon: <Clapperboard className="w-8 h-8" />,
      title: "CINEMATIC GROWTH",
      description: "Visual production with international standards.",
      features: [
        { icon: <Film className="w-5 h-5" />, text: "Ad-optimized Reels" },
        { icon: <Video className="w-5 h-5" />, text: "Professional sports production" },
        { icon: <BookOpen className="w-5 h-5" />, text: "Storytelling documentaries" },
        { icon: <Building2 className="w-5 h-5" />, text: "Corporate video" },
        { icon: <Camera className="w-5 h-5" />, text: "Professional photography" }
      ],
      colorClass: "pillar-cinematic",
      accentColor: "text-cyan-400",
      glowColor: "group-hover:shadow-rose-500/20"
    }
  ];
  
  const pillars = lang === 'es' ? pillarsES : pillarsEN;

  return (
    <section id="pilares" className="py-24 md:py-32 px-6" data-testid="pillars-section">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="font-syne font-bold text-3xl sm:text-4xl md:text-5xl mb-4" data-testid="pillars-title">
            {t.pillars.title}
          </h2>
          <p className="font-manrope text-white/50">{t.pillars.subtitle}</p>
        </motion.div>
        
        <motion.div 
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8"
        >
          {pillars.map((pillar) => (
            <motion.div
              key={pillar.id}
              variants={fadeUpVariants}
              className={`pillar-card ${pillar.colorClass} group`}
              data-testid={`pillar-${pillar.id}`}
            >
              <div className={`${pillar.accentColor} mb-6`}>
                {pillar.icon}
              </div>
              <h3 className="font-syne font-bold text-2xl mb-3">{pillar.title}</h3>
              <p className="font-manrope text-white/60 mb-6">{pillar.description}</p>
              <ul className="space-y-3">
                {pillar.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center gap-3 text-white/70 group-hover:text-white/90 transition-colors">
                    <span className={pillar.accentColor}>{feature.icon}</span>
                    <span className="font-space text-sm">{feature.text}</span>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

// Results/Stats Section
const ResultsSection = () => {
  const { lang, t } = useLanguage();
  
  const resultsES = [
    { id: 1, number: "+200K", title: "Ventas anuales generadas", sector: "Healthcare Product (E-Commerce)", country: "Estados Unidos", description: "Optimización estratégica de marketplace + pauta interna + mejora continua de conversión." },
    { id: 2, number: "+25%", title: "Incremento en reservas Airbnb", sector: "Hospitality Premium", country: "México", description: "Tráfico calificado + producción visual premium + posicionamiento internacional." },
    { id: 3, number: "$15K", subtitle: "/ mes", title: "Reservas mensuales sostenidas", sector: "Turismo & Experiencia", country: "Ecuador", description: "Construcción de marca desde cero + performance digital + embudo optimizado." },
    { id: 4, number: "+30%", title: "Aumento en engagement estratégico", sector: "Luxury Hospitality", country: "México", description: "Influencer marketing estructurado + narrativa visual cinematográfica." },
    { id: 5, number: "+88K", title: "Comunidad Construida", sector: "Múltiples sectores", country: "Internacional", description: "Crecimiento impulsado por performance marketing, contenido optimizado y campañas estructuradas." },
    { id: 6, number: "+1.4M", title: "Visualizaciones en contenido estratégico", sector: "Moda", country: "Ecuador", description: "Reel optimizado con estructura de hook, retención y narrativa visual diseñada para alcance masivo." }
  ];
  
  const resultsEN = [
    { id: 1, number: "+200K", title: "Annual sales generated", sector: "Healthcare Product (E-Commerce)", country: "United States", description: "Strategic marketplace optimization + internal ads + continuous conversion improvement." },
    { id: 2, number: "+25%", title: "Increase in Airbnb bookings", sector: "Hospitality Premium", country: "Mexico", description: "Qualified traffic + premium visual production + international positioning." },
    { id: 3, number: "$15K", subtitle: "/ month", title: "Sustained monthly bookings", sector: "Tourism & Experience", country: "Ecuador", description: "Brand building from scratch + digital performance + optimized funnel." },
    { id: 4, number: "+30%", title: "Strategic engagement increase", sector: "Luxury Hospitality", country: "Mexico", description: "Structured influencer marketing + cinematic visual narrative." },
    { id: 5, number: "+88K", title: "Community Built", sector: "Multiple sectors", country: "International", description: "Growth driven by performance marketing, optimized content and structured campaigns." },
    { id: 6, number: "+1.4M", title: "Views on strategic content", sector: "Fashion", country: "Ecuador", description: "Optimized reel with hook structure, retention and visual narrative designed for massive reach." }
  ];
  
  const results = lang === 'es' ? resultsES : resultsEN;

  return (
    <section id="resultados" className="py-24 md:py-32 px-6" data-testid="results-section">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="font-syne font-bold text-3xl sm:text-4xl md:text-5xl mb-4" data-testid="results-title">
            {t.results.title}
          </h2>
          <p className="font-manrope text-white/50">{t.results.subtitle}</p>
        </motion.div>
        
        <motion.div 
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8"
        >
          {results.map((result) => (
            <motion.div
              key={result.id}
              variants={fadeUpVariants}
              className="bg-[#0A0A0A] border border-white/5 rounded-2xl p-8 hover:border-cyan-400/20 transition-all duration-500"
              data-testid={`result-${result.id}`}
            >
              <div className="mb-6">
                <span className="font-syne font-bold text-5xl md:text-6xl text-gradient-cinematic">
                  {result.number}
                </span>
                {result.subtitle && (
                  <span className="font-syne font-bold text-2xl md:text-3xl text-white/60">
                    {result.subtitle}
                  </span>
                )}
              </div>
              
              <h3 className="font-syne font-bold text-xl md:text-2xl text-white mb-4">
                {result.title}
              </h3>
              
              <div className="flex flex-wrap gap-4 mb-4">
                <div className="flex items-center gap-2">
                  <span className="font-space text-xs text-white/40 uppercase tracking-wider">Sector:</span>
                  <span className="font-space text-sm text-white/70">{result.sector}</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="font-space text-xs text-white/40 uppercase tracking-wider">País:</span>
                  <span className="font-space text-sm text-cyan-400">{result.country}</span>
                </div>
              </div>
              
              <p className="font-manrope text-sm text-white/50 leading-relaxed">
                {result.description}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

// Portfolio Videos Section
const PortfolioVideosSection = () => {
  const { t } = useLanguage();
  const [isMobile, setIsMobile] = React.useState(false);

  React.useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const mainVideo = {
    id: 0,
    title: "Terrocal - 20 Años de Experiencia",
    url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/c1akk1yq_%C2%A1Construye%20con%20Terrocal%20y%20marca%20la%20diferencia%21%20Confi%CC%81a%20en%20nuestra%20experiencia%20de%2020%20an%CC%83os%20en%20const.mp4",
    category: "Corporativo"
  };

  const videos = [
    { 
      id: 1, 
      title: "Materia - Diseño de Hogar", 
      url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/3yia79tb_%C2%A1Disen%CC%83a%20tu%20hogar%20moderno%20con%20MATERIA%21%20%C2%BFSuen%CC%83as%20con%20una%20casa%20que%20refleje%20tu%20estilo%20u%CC%81nico%20y%20abrace%20.mp4",
      category: "Producción"
    },
    { 
      id: 2, 
      title: "Maimará Glamping", 
      url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/t6517ccw_%C2%BFListo%20para%20una%20aventura%20inolvidable%20Visi%CC%81tanos%20en%20Maimara%20Glamping%20%F0%9F%8F%94%EF%B8%8F%20%F0%9F%87%AA%F0%9F%87%A8%20Domos%20-%20Restaurante-.mp4",
      category: "Turismo"
    },
    { 
      id: 3, 
      title: "Maimará Experience", 
      url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/estor6dw_%C2%BFListo%20para%20una%20experiencia%20excepcional%20Maimara%CC%81%20te%20sorprendera%CC%81%20con%20su%20encanto%20%E2%9C%A8Escapa%20este%20fin%20d.mp4",
      category: "Lifestyle"
    },
    { 
      id: 21, 
      title: "Historia de Campeón", 
      url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/01eqqkf6_Detra%CC%81s%20de%20cada%20campeo%CC%81n%20hay%20una%20decisio%CC%81n.Elegir%20equipo.%20Elegir%20visio%CC%81n.%20Elegir%20camino.Hoy%20caminamo.mp4",
      category: "Deportes"
    },
    { 
      id: 4, 
      title: "Maimará Spa", 
      url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/zz12xsmk_%E2%9C%A8%20El%20mejor%20plan%20para%20desconectar%20existe%20%E2%9C%A8Nuestro%20spa%20en%20Maimara%CC%81%20ya%20esta%CC%81%20abierto%2C%20un%20espacio%20crea.mp4",
      category: "Wellness"
    },
    { 
      id: 5, 
      title: "Producción Cinematográfica", 
      url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/777cmtv7_4.mp4",
      category: "Cinematic"
    },
    { 
      id: 6, 
      title: "Reel Deportivo", 
      url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/wyypas5z_5.mp4",
      category: "Deportes"
    },
    { 
      id: 7, 
      title: "Video Corporativo", 
      url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/l0vly3nc_8.mp4",
      category: "Corporativo"
    },
    { 
      id: 8, 
      title: "Behind The Scenes", 
      url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/kgtfos9k_020599.mov",
      category: "BTS"
    },
    { 
      id: 9, 
      title: "Materia Arquitectura - Fundadora", 
      url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/6sb671b9_Desde%20Materia%20Arquitectura%2C%20nos%20enorgullece%20que%20nuestra%20fundadora%2C%20Marisa%20Paz%2C%20haya%20sido%20invitad.mp4",
      category: "Entrevista"
    },
    { 
      id: 10, 
      title: "Alfombras de Guano - Documental", 
      url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/63xicjds_El%20legado%20de%20las%20alfombras%20anudadas%20de%20Guano%20sigue%20vivo%20gracias%20a%20las%20familias%20que%20lo%20han%20preser.mp4",
      category: "Documental"
    },
    { 
      id: 11, 
      title: "Dobinsons 4x4 Suspensiones", 
      url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/w3czjk49_Convierte%20tu%204x4%20en%20una%20verdadera%20ma%CC%81quina%20de%20desempen%CC%83o.Instala%20suspensiones%20Dobinsons%20y%20eleva%20tu.mp4",
      category: "Automotriz"
    },
    { 
      id: 12, 
      title: "Ford F-150 Raptor 4x4", 
      url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/gl6p751y_%F0%9F%94%A5%20Descubre%20la%20Ford%20F-150%20Raptor%204x4%202017-%20motor%203.500cc%20Twin-Turbo%20de%20450HP%2C%20suspensio%CC%81n%20FOX%20Rac.mp4",
      category: "Automotriz"
    },
    { 
      id: 13, 
      title: "Casa China Blanca - Punta Mita", 
      url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/y2n1xkvm_Escape%20to%20paradise%20in%20Punta%20Mita%2C%20Mexico%21%20%F0%9F%8C%8A%20%F0%9F%87%B2%F0%9F%87%BD%20Casa%20China%20Blanca%20has%20everything%20you%20need%20for%20.mp4",
      category: "Luxury"
    },
    { 
      id: 14, 
      title: "Casa China Blanca Villa", 
      url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/6kzxh2vj_Discover%20Casa%20China%20Blanca%20%E2%80%94%20Punta%20Mita%E2%80%99s%20most%20iconic%20oceanfront%20villa.%205%20luxe%20suites%2C%20infinity%20.mp4",
      category: "Real Estate"
    },
    { 
      id: 15, 
      title: "Gentle Drop - Eye Care", 
      url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/99moh8es_%40drjenandjuice%20Explores%20the%20ease%20and%20precision%20of%20our%20eye%20drop%20aid%E2%80%94a%20game-changer%20in%20personal%20ey%20%281%29.mp4",
      category: "Producto"
    },
    { 
      id: 16, 
      title: "Maimará - Pesillo", 
      url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/d0bjvr1v_Maimara%CC%81%20te%20asombrara%CC%81%20%F0%9F%8F%94%EF%B8%8F%20%F0%9F%8C%9E%20Estamos%20ubicados%20a%2090%20minutos%20de%20Quito%20en%20Pesillo%20%F0%9F%90%8E%20%C2%A1%20Conta%CC%81ctanos%20p.mp4",
      category: "Turismo"
    },
    { 
      id: 17, 
      title: "Taller de Diseño - Quito", 
      url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/gbh32fci_Un%20vistazo%20final%20a%20una%20tarde%20que%20nos%20recordo%CC%81%20por%20que%CC%81%20disen%CC%83amos-%20para%20conectar.%20%F0%9F%AB%82El%20taller%20de%20Qu.mp4",
      category: "Evento"
    },
    { 
      id: 18, 
      title: "Bear's Head - Journaling", 
      url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/wasdn8ge_%E2%9C%A8%20Imagine%20journaling%20as%20the%20ocean%20becomes%20your%20muse.%20At%20Bear%E2%80%99s%20Head%2C%20every%20sunrise%20invites%20refle.mp4",
      category: "Lifestyle"
    },
    { 
      id: 19, 
      title: "Whale Watching - Punta Mita", 
      url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/dgdlbo2e_During%20your%20stay%20in%20Punta%20de%20Mita%2C%20immerse%20yourself%20in%20the%20magic%20of%20whale%20watching%21%20%F0%9F%90%8B%20Embark%20on.mp4",
      category: "Experiencia"
    },
    { 
      id: 20, 
      title: "Casa China Blanca - Getaway", 
      url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/xvua0c4q_Dreaming%20of%20your%20next%20getaway%20Imagine%20yourself%20at%20Casa%20China%20Blanca%2C%20where%20luxury%20meets%20paradise.mp4",
      category: "Luxury"
    }
  ];

  return (
    <section id="videos" className="py-24 md:py-32 px-6 bg-[#0a0a0a]" data-testid="videos-section">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="font-syne font-bold text-3xl sm:text-4xl md:text-5xl mb-4" data-testid="videos-title">
            {t.portfolio.title}
          </h2>
          <p className="font-manrope text-white/50">{t.portfolio.subtitle}</p>
        </motion.div>
        
        {/* Main featured video */}
        <MainVideoPlayer video={mainVideo} />

        {/* Videos grid - Limited for performance */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3 md:gap-4">
          {(isMobile ? videos.slice(0, 4) : videos.slice(0, 10)).map((video) => (
            <VideoThumbnail key={video.id} video={video} />
          ))}
        </div>
        
        {videos.length > 10 && (
          <p className="text-center text-white/40 text-sm mt-6 font-space">
            +{videos.length - (isMobile ? 4 : 10)} videos más disponibles
          </p>
        )}
      </div>
    </section>
  );
};

// Photography Section
const PhotographySection = () => {
  const { t } = useLanguage();
  const [isMobile, setIsMobile] = React.useState(false);

  React.useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const photos = [
    { 
      id: 1, 
      title: "Romina's Bar", 
      url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/xz832kzj_Te%20presentamos%20un%20nuevo%20proyecto-%20Romina%E2%80%99s%20Bar%20%F0%9F%8D%B8%E2%9C%A8Un%20espacio%20donde%20el%20disen%CC%83o%20se%20convierte%20en%20pro.jpg",
      category: "Comercial"
    },
    { 
      id: 2, 
      title: "Materia - Diseño Interior", 
      url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/iptxfokp_En%20Materia%2C%20creemos%20que%20el%20disen%CC%83o%20no%20solo%20se%20trata%20de%20este%CC%81tica%2C%20sino%20de%20soluciones%20bien%20pensadas.jpg",
      category: "Arquitectura"
    },
    { 
      id: 3, 
      title: "Bear's Head - Oregon", 
      url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/5klgp8yi_Winter%20whispers%20along%20the%20waves%20at%20Bears%20Head%2C%20Arch%20Cape%2C%20OR.Curl%20by%20the%20fire%20with%20wine%20%F0%9F%8D%B7%20as%20st.jpg",
      category: "Paisaje"
    },
    { 
      id: 4, 
      title: "Casa China Blanca - Fashion", 
      url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/aqqld0us_%E2%9C%94%EF%B8%8F_DSC2577%20copia.jpg",
      category: "Moda"
    },
    { 
      id: 5, 
      title: "Casa China Blanca - Luxury", 
      url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/knvrwkux_Casa%20China%20Blanca%20is%20pure%20magic.%20%E2%9C%A8%23Travel%20%23LuxuryVilla%20%23CasaChinaBlanca%20%20%23VacationGoals%20%23PuntaMi.jpg",
      category: "Interiorismo"
    },
    { 
      id: 6, 
      title: "Cacao Fuel - Lifestyle", 
      url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/om0lb2l6_Introducing%20Cacao%20FuelSmoothies%20for%20every%20taste.Pre%20or%20post%20workout%2C%20we%E2%80%99ve%20got%20you..jpg",
      category: "Moda"
    },
    { 
      id: 7, 
      title: "Maimará Fleece", 
      url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/7xuw44z6__A744232-removebg-preview.png",
      category: "Producto"
    },
    { 
      id: 8, 
      title: "Cayambe - Maimará", 
      url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/pem47udj_Hermoso%20amanecer%20en%20Maimara%CC%81%20%F0%9F%8C%9E%20El%20majestuoso%20cayambe%20visto%20desde%20nuestro%20mirador%20%F0%9F%93%B8%20%F0%9F%8F%94%EF%B8%8F.jpg",
      category: "Paisaje"
    },
    { 
      id: 9, 
      title: "Anku - New Drop", 
      url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/f3q8nn2u_New%20Drop%20Loading%E2%80%A6%20%F0%9F%8E%84%203%E2%80%A212%E2%80%A225..jpg",
      category: "Moda"
    },
    { 
      id: 10, 
      title: "Caballos - Maimará", 
      url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/be2tkcp0_Los%20caballos%20son%20uno%20de%20los%20atractivos%20principales%20en%20nuestra%20hacienda%20%F0%9F%90%8E%20Visi%CC%81tanos%20y%20disfruta%20d.jpg",
      category: "Naturaleza"
    },
    { 
      id: 11, 
      title: "Sierra Domo - Cóctel", 
      url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/inf4g6ez_En%20Sierra%20Domo%20Restaurante%20Bar%2C%20cada%20co%CC%81ctel%20es%20una%20experiencia%20entre%20montan%CC%83as%2C%20mu%CC%81sica%20y%20buena%20co.jpg",
      category: "Gastronomía"
    },
    { 
      id: 12, 
      title: "Terrocal - Construcción", 
      url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/f0vgveuw_%F0%9F%94%A7%20El%20trabajo%20bien%20hecho%20empieza%20desde%20el%20compromiso%20diario.Cada%20esfuerzo%20cuenta%20en%20la%20construcc.jpg",
      category: "Industrial"
    },
    { 
      id: 13, 
      title: "Mercedes-Benz ML 63 AMG", 
      url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/kjdnt723_%F0%9F%9A%99%E2%9C%A8%20%C2%A1En%20Venta%21%20MERCEDES-BENZ%20ML%2063%20AMG%20-%202014%20%F0%9F%8C%9FCaracteri%CC%81sticas%20Principales-%E2%9C%85%20Modelo-%20Mercedes-B.jpg",
      category: "Automotriz"
    },
    { 
      id: 14, 
      title: "Anku - Naturaleza", 
      url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/940ioess_Feel%20the%20nature%20%F0%9F%8D%83%F0%9F%99%8F%F0%9F%8F%BB%E2%80%A2%E2%80%A2%E2%80%A2%20%F0%9F%93%B8%20%40_asphraw_%20%E2%80%A2%23saldeloordinario%20%23pachas%20%23anku%20%23sostenibilidad%20%23sustai.jpg",
      category: "Lifestyle",
      objectPosition: "top"
    },
    { 
      id: 15, 
      title: "Bear's Head - Interior", 
      url: "https://customer-assets.emergentagent.com/job_fxr-data-ia/artifacts/x2x0mwr1_Bear%E2%80%99s%20Head%20is%20a%20mid-century%20gem%20with%20sleek%20furnishings%20and%20ocean%20views.%20Unwind%20by%20the%20wood-burn.jpg",
      category: "Interiorismo"
    }
  ];

  return (
    <section id="fotografia" className="py-24 md:py-32 px-6" data-testid="photography-section">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="font-syne font-bold text-3xl sm:text-4xl md:text-5xl mb-4" data-testid="photography-title">
            {t.photography.title}
          </h2>
          <p className="font-manrope text-white/50">{t.photography.subtitle}</p>
        </motion.div>
        
        <motion.div 
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid grid-cols-2 md:grid-cols-3 gap-4"
        >
          {(isMobile ? photos.slice(0, 6) : photos).map((photo, idx) => (
            <motion.div
              key={photo.id}
              variants={fadeUpVariants}
              className={`relative rounded-xl overflow-hidden group cursor-pointer ${idx === 0 && !isMobile ? 'md:col-span-2 md:row-span-2' : ''}`}
              data-testid={`photo-item-${photo.id}`}
            >
              <div className={`relative ${idx === 0 && !isMobile ? 'aspect-square md:aspect-[4/3]' : 'aspect-square'} bg-[#111]`}>
                <img
                  src={photo.url}
                  alt={photo.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                  style={{ objectPosition: photo.objectPosition || 'center' }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <div className="absolute bottom-0 left-0 right-0 p-4 translate-y-full group-hover:translate-y-0 transition-transform duration-500">
                  <span className="font-space text-xs uppercase tracking-widest text-cyan-400 mb-1 block">
                    {photo.category}
                  </span>
                  <h3 className="font-syne font-bold text-sm md:text-base text-white">
                    {photo.title}
                  </h3>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
        
        {isMobile && photos.length > 6 && (
          <p className="text-center text-white/40 text-sm mt-6 font-space">
            +{photos.length - 6} fotos más en versión desktop
          </p>
        )}
      </div>
    </section>
  );
};

// Portfolio Section
const PortfolioSection = () => {
  const { lang, t } = useLanguage();
  
  const servicesES = [
    { id: 1, title: "Gestión de Redes Sociales", category: "Social Media", description: "Administración completa de tus perfiles" },
    { id: 2, title: "Creación de Contenido", category: "Content", description: "Posteos, reels y stories optimizados" },
    { id: 3, title: "Pauta Digital", category: "Meta Ads", description: "Campañas en Facebook e Instagram" },
    { id: 4, title: "Producción Audiovisual", category: "Video", description: "Videos profesionales de alto impacto" },
    { id: 5, title: "Estrategia de Marca", category: "Branding", description: "Posicionamiento y diferenciación" },
    { id: 6, title: "Automatización con IA", category: "AI", description: "Chatbots y flujos automatizados" },
    { id: 7, title: "Fotografía Profesional", category: "Photo", description: "Sesiones de producto y corporativas" },
    { id: 8, title: "Community Management", category: "Social Media", description: "Interacción y crecimiento de comunidad" }
  ];
  
  const servicesEN = [
    { id: 1, title: "Social Media Management", category: "Social Media", description: "Complete profile administration" },
    { id: 2, title: "Content Creation", category: "Content", description: "Optimized posts, reels and stories" },
    { id: 3, title: "Digital Advertising", category: "Meta Ads", description: "Facebook & Instagram campaigns" },
    { id: 4, title: "Audiovisual Production", category: "Video", description: "High-impact professional videos" },
    { id: 5, title: "Brand Strategy", category: "Branding", description: "Positioning and differentiation" },
    { id: 6, title: "AI Automation", category: "AI", description: "Chatbots and automated flows" },
    { id: 7, title: "Professional Photography", category: "Photo", description: "Product and corporate sessions" },
    { id: 8, title: "Community Management", category: "Social Media", description: "Interaction and community growth" }
  ];
  
  const services = lang === 'es' ? servicesES : servicesEN;

  return (
    <section id="portafolio" className="py-24 md:py-32 px-6" data-testid="portfolio-section">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="font-syne font-bold text-3xl sm:text-4xl md:text-5xl mb-4" data-testid="portfolio-title">
            {t.services.title}
          </h2>
          <p className="font-manrope text-white/50">{t.services.subtitle}</p>
        </motion.div>
        
        <motion.div 
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4"
        >
          {services.map((item) => (
            <motion.div
              key={item.id}
              variants={fadeUpVariants}
              className="bg-[#0F0F0F] border border-white/5 rounded-2xl p-6 hover:border-cyan-400/30 transition-all duration-500 group cursor-pointer"
              data-testid={`service-item-${item.id}`}
            >
              <span className="font-space text-xs uppercase tracking-widest text-cyan-400 mb-3 block">
                {item.category}
              </span>
              <h3 className="font-syne font-bold text-xl text-white mb-2 group-hover:text-cyan-400 transition-colors">
                {item.title}
              </h3>
              <p className="font-manrope text-sm text-white/50">
                {item.description}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

// Brands Carousel Section - Infinite scroll with larger logos
const BrandsSection = () => {
  const { t } = useLanguage();
  return (
    <section id="marcas" className="py-24 md:py-32 overflow-hidden bg-white" data-testid="brands-section">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="font-syne font-bold text-3xl sm:text-4xl md:text-5xl mb-4 text-black" data-testid="brands-title">
            {t.brands.title}
          </h2>
          <p className="font-manrope text-black/50">{t.brands.subtitle}</p>
        </motion.div>
      </div>
      
      {/* Infinite Carousel - Larger logos */}
      <div className="relative">
        <div className="absolute left-0 top-0 bottom-0 w-20 md:w-40 bg-gradient-to-r from-white to-transparent z-10" />
        <div className="absolute right-0 top-0 bottom-0 w-20 md:w-40 bg-gradient-to-l from-white to-transparent z-10" />
        
        <div className="brand-carousel animate-scroll-left">
          {[...CLIENT_LOGOS, ...CLIENT_LOGOS].map((logo, idx) => (
            <div 
              key={idx} 
              className="flex-shrink-0 mx-4 md:mx-8 bg-gray-50 rounded-2xl p-6 md:p-8 flex items-center justify-center border border-gray-100 hover:shadow-lg transition-shadow"
              data-testid={`brand-logo-${idx}`}
            >
              <img 
                src={logo.url} 
                alt={logo.name}
                className="h-16 md:h-24 lg:h-28 w-auto max-w-[120px] md:max-w-[180px] object-contain"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Integrations Section - Infinite Carousel
const IntegrationsSection = () => {
  const { t } = useLanguage();
  return (
    <section id="integraciones" className="py-20 md:py-28 bg-[#0a0a0a] overflow-hidden" data-testid="integrations-section">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="font-syne font-bold text-3xl sm:text-4xl md:text-5xl mb-4 text-white" data-testid="integrations-title">
            {t.integrations.title}
          </h2>
          <p className="font-manrope text-white/50">{t.integrations.subtitle}</p>
        </motion.div>
      </div>
      
      {/* Infinite Carousel */}
      <div className="relative">
        <div className="absolute left-0 top-0 bottom-0 w-20 md:w-40 bg-gradient-to-r from-[#0a0a0a] to-transparent z-10" />
        <div className="absolute right-0 top-0 bottom-0 w-20 md:w-40 bg-gradient-to-l from-[#0a0a0a] to-transparent z-10" />
        
        <div className="integration-carousel animate-scroll-left">
          {[...INTEGRATION_LOGOS, ...INTEGRATION_LOGOS].map((logo, idx) => (
            <div 
              key={idx} 
              className="flex-shrink-0 mx-4 md:mx-6 bg-white/5 border border-white/10 rounded-2xl p-6 md:p-8 flex items-center justify-center hover:bg-white/10 hover:border-cyan-400/30 transition-all"
              data-testid={`integration-logo-${idx}`}
            >
              <img 
                src={logo.url} 
                alt={logo.name}
                className="h-12 md:h-16 w-auto max-w-[120px] md:max-w-[150px] object-contain brightness-0 invert opacity-80"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Official Partners Section
const OfficialPartnersSection = () => {
  const { t } = useLanguage();
  return (
    <section id="partners" className="py-20 md:py-28 bg-white" data-testid="partners-section">
      <div className="max-w-6xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="font-syne font-bold text-3xl sm:text-4xl md:text-5xl mb-4 text-black" data-testid="partners-title">
            {t.partners.title}
          </h2>
          <p className="font-manrope text-black/50">{t.partners.subtitle}</p>
        </motion.div>
        
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {/* We Speak */}
          <motion.div 
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            className="flex justify-center"
          >
            <div className="bg-gray-50 border border-gray-200 rounded-3xl p-10 md:p-14 flex flex-col items-center justify-center hover:shadow-xl transition-shadow duration-300 w-full">
              <img 
                src={WESPEAK_LOGO}
                alt="We Speak"
                className="h-28 md:h-40 lg:h-48 w-auto object-contain mb-4"
              />
              <span className="font-space text-sm text-black/40 uppercase tracking-widest">{t.partners.badge}</span>
            </div>
          </motion.div>
          
          {/* Talk Base Studio */}
          <motion.div 
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="flex justify-center"
          >
            <div className="bg-gray-50 border border-gray-200 rounded-3xl p-10 md:p-14 flex flex-col items-center justify-center hover:shadow-xl transition-shadow duration-300 w-full">
              <img 
                src={TALKBASE_LOGO}
                alt="Talk Base Studio"
                className="h-28 md:h-40 lg:h-48 w-auto object-contain mb-4"
              />
              <span className="font-space text-sm text-black/40 uppercase tracking-widest">{t.partners.badge}</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

// International Presence Section
const PresenceSection = () => {
  const { lang, t } = useLanguage();
  
  const locationsES = [
    { name: "Oregon, Estados Unidos", x: "18%", y: "22%" },
    { name: "Punta de Mita, México", x: "22%", y: "42%" },
    { name: "Quito, Ecuador", x: "32%", y: "62%" },
    { name: "Madrid, España", x: "72%", y: "28%" }
  ];
  
  const locationsEN = [
    { name: "Oregon, United States", x: "18%", y: "22%" },
    { name: "Punta de Mita, Mexico", x: "22%", y: "42%" },
    { name: "Quito, Ecuador", x: "32%", y: "62%" },
    { name: "Madrid, Spain", x: "72%", y: "28%" }
  ];
  
  const locations = lang === 'es' ? locationsES : locationsEN;

  return (
    <section id="presencia" className="py-24 md:py-32 px-6" data-testid="presence-section">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="font-syne font-bold text-3xl sm:text-4xl md:text-5xl mb-4" data-testid="presence-title">
            {t.presence.title}
          </h2>
        </motion.div>
        
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="map-container relative bg-[#0a0a0a] rounded-2xl p-8 border border-white/5"
        >
          {/* Americas Map SVG */}
          <svg viewBox="0 0 400 500" className="w-full h-auto max-h-[500px]">
            {/* North America */}
            <path 
              d="M50,20 L120,15 L180,25 L200,20 L220,35 L200,50 L180,45 L160,60 L140,55 L120,70 L100,65 L80,80 L60,75 L50,90 L40,85 L30,100 L25,90 L20,80 L30,60 L40,40 Z" 
              fill="rgba(255,255,255,0.08)" 
              stroke="rgba(0, 217, 192, 0.3)" 
              strokeWidth="1"
            />
            {/* USA */}
            <path 
              d="M30,100 L50,95 L80,100 L120,95 L160,100 L180,110 L170,125 L150,130 L130,125 L100,135 L70,130 L50,140 L40,135 L30,145 L25,130 L20,115 Z" 
              fill="rgba(255,255,255,0.1)" 
              stroke="rgba(0, 217, 192, 0.4)" 
              strokeWidth="1"
            />
            {/* Mexico */}
            <path 
              d="M30,145 L50,140 L70,150 L100,155 L120,170 L130,190 L120,210 L100,220 L80,215 L60,200 L50,180 L40,165 L30,160 Z" 
              fill="rgba(255,255,255,0.1)" 
              stroke="rgba(0, 217, 192, 0.4)" 
              strokeWidth="1"
            />
            {/* Central America */}
            <path 
              d="M100,220 L120,225 L130,240 L125,260 L115,275 L105,270 L95,255 L90,240 L95,225 Z" 
              fill="rgba(255,255,255,0.08)" 
              stroke="rgba(0, 217, 192, 0.3)" 
              strokeWidth="1"
            />
            {/* Colombia */}
            <path 
              d="M105,275 L130,280 L150,290 L160,310 L155,330 L140,340 L120,335 L100,320 L95,300 L100,285 Z" 
              fill="rgba(255,255,255,0.08)" 
              stroke="rgba(0, 217, 192, 0.3)" 
              strokeWidth="1"
            />
            {/* Ecuador */}
            <path 
              d="M95,300 L100,320 L95,340 L80,345 L70,335 L75,315 L85,305 Z" 
              fill="rgba(0, 217, 192, 0.15)" 
              stroke="rgba(0, 217, 192, 0.6)" 
              strokeWidth="1.5"
            />
            {/* Peru */}
            <path 
              d="M70,345 L95,340 L100,360 L95,390 L80,410 L60,400 L50,380 L55,360 Z" 
              fill="rgba(255,255,255,0.08)" 
              stroke="rgba(0, 217, 192, 0.3)" 
              strokeWidth="1"
            />
            {/* Brazil */}
            <path 
              d="M140,340 L180,335 L220,350 L250,380 L260,420 L240,460 L200,470 L160,460 L130,430 L120,390 L125,360 Z" 
              fill="rgba(255,255,255,0.08)" 
              stroke="rgba(0, 217, 192, 0.3)" 
              strokeWidth="1"
            />
            {/* Argentina & Chile */}
            <path 
              d="M80,410 L100,420 L120,450 L130,480 L120,510 L100,520 L80,510 L70,480 L65,450 L70,430 Z" 
              fill="rgba(255,255,255,0.08)" 
              stroke="rgba(0, 217, 192, 0.3)" 
              strokeWidth="1"
            />
            
            {/* Europe */}
            <path 
              d="M330,80 L360,75 L400,80 L420,100 L410,130 L380,150 L350,145 L320,130 L310,110 L315,90 Z" 
              fill="rgba(255,255,255,0.08)" 
              stroke="rgba(0, 217, 192, 0.3)" 
              strokeWidth="1"
            />
            {/* Spain - Larger Iberian Peninsula shape */}
            <path 
              d="M305,140 L320,135 L340,133 L360,138 L372,148 L375,160 L372,172 L365,182 L350,188 L330,190 L315,186 L305,180 L300,170 L302,155 Z" 
              fill="rgba(0, 217, 192, 0.2)" 
              stroke="rgba(0, 217, 192, 0.8)" 
              strokeWidth="2"
            />
            {/* UK */}
            <path 
              d="M320,90 L335,85 L340,100 L335,115 L325,110 L318,100 Z" 
              fill="rgba(255,255,255,0.08)" 
              stroke="rgba(0, 217, 192, 0.3)" 
              strokeWidth="1"
            />
            {/* Africa */}
            <path 
              d="M345,165 L380,160 L420,180 L440,220 L430,280 L400,320 L360,330 L330,310 L320,270 L325,220 L335,185 Z" 
              fill="rgba(255,255,255,0.08)" 
              stroke="rgba(0, 217, 192, 0.3)" 
              strokeWidth="1"
            />
            
            {/* Connection lines */}
            <line x1="72" y1="110" x2="88" y2="195" stroke="rgba(0, 217, 192, 0.4)" strokeWidth="1" strokeDasharray="4,4" />
            <line x1="88" y1="195" x2="85" y2="320" stroke="rgba(0, 217, 192, 0.4)" strokeWidth="1" strokeDasharray="4,4" />
            <line x1="85" y1="320" x2="340" y2="160" stroke="rgba(0, 217, 192, 0.4)" strokeWidth="1" strokeDasharray="4,4" />
            
            {/* Oregon, USA - Dot */}
            <g className="cursor-pointer" data-testid="map-location-0">
              <circle cx="72" cy="110" r="8" fill="#050505" stroke="#00D9C0" strokeWidth="2" />
              <circle cx="72" cy="110" r="4" fill="#00D9C0" />
              <circle cx="72" cy="110" r="12" fill="transparent" stroke="#00D9C0" strokeWidth="1" opacity="0.5">
                <animate attributeName="r" values="12;18;12" dur="2s" repeatCount="indefinite" />
                <animate attributeName="opacity" values="0.5;0;0.5" dur="2s" repeatCount="indefinite" />
              </circle>
            </g>
            
            {/* Punta de Mita, Mexico - Dot */}
            <g className="cursor-pointer" data-testid="map-location-1">
              <circle cx="88" cy="195" r="8" fill="#050505" stroke="#00D9C0" strokeWidth="2" />
              <circle cx="88" cy="195" r="4" fill="#00D9C0" />
              <circle cx="88" cy="195" r="12" fill="transparent" stroke="#00D9C0" strokeWidth="1" opacity="0.5">
                <animate attributeName="r" values="12;18;12" dur="2s" repeatCount="indefinite" begin="0.5s" />
                <animate attributeName="opacity" values="0.5;0;0.5" dur="2s" repeatCount="indefinite" begin="0.5s" />
              </circle>
            </g>
            
            {/* Quito, Ecuador - Dot */}
            <g className="cursor-pointer" data-testid="map-location-2">
              <circle cx="85" cy="320" r="8" fill="#050505" stroke="#00D9C0" strokeWidth="2" />
              <circle cx="85" cy="320" r="4" fill="#00D9C0" />
              <circle cx="85" cy="320" r="12" fill="transparent" stroke="#00D9C0" strokeWidth="1" opacity="0.5">
                <animate attributeName="r" values="12;18;12" dur="2s" repeatCount="indefinite" begin="1s" />
                <animate attributeName="opacity" values="0.5;0;0.5" dur="2s" repeatCount="indefinite" begin="1s" />
              </circle>
            </g>
            
            {/* Madrid, Spain - Dot (centered in Spain) */}
            <g className="cursor-pointer" data-testid="map-location-3">
              <circle cx="340" cy="160" r="8" fill="#050505" stroke="#00D9C0" strokeWidth="2" />
              <circle cx="340" cy="160" r="4" fill="#00D9C0" />
              <circle cx="340" cy="160" r="12" fill="transparent" stroke="#00D9C0" strokeWidth="1" opacity="0.5">
                <animate attributeName="r" values="12;18;12" dur="2s" repeatCount="indefinite" begin="1.5s" />
                <animate attributeName="opacity" values="0.5;0;0.5" dur="2s" repeatCount="indefinite" begin="1.5s" />
              </circle>
            </g>
            
            {/* Labels */}
            <text x="95" y="108" fill="#00D9C0" fontSize="10" fontWeight="500">Oregon, USA</text>
            <text x="105" y="200" fill="#00D9C0" fontSize="10" fontWeight="500">Punta de Mita, MX</text>
            <text x="100" y="325" fill="#00D9C0" fontSize="10" fontWeight="500">Quito, Ecuador</text>
            <text x="355" y="165" fill="#00D9C0" fontSize="10" fontWeight="500" style={{display: lang === 'es' ? 'block' : 'none'}}>Madrid, España</text>
            <text x="355" y="165" fill="#00D9C0" fontSize="10" fontWeight="500" style={{display: lang === 'en' ? 'block' : 'none'}}>Madrid, Spain</text>
          </svg>
        </motion.div>
        
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center text-white/60 font-manrope mt-12 max-w-2xl mx-auto"
        >
          {lang === 'es' 
            ? 'Trabajamos con clientes en múltiples mercados, aplicando sistemas de crecimiento estructurados y producción audiovisual de alto estándar.'
            : 'We work with clients in multiple markets, applying structured growth systems and high-standard audiovisual production.'
          }
        </motion.p>
      </div>
    </section>
  );
};

// Team Section
const FRANCISCO_PHOTO = "https://customer-assets-lqy194kg.emergentagent.net/job_0e1ba4ee-a725-40b4-9962-4ddff85eb22c/artifacts/3d5ae8dbc260e42b_Grayscale%20Portrait%20with%20Branded%20T-Shirt.png";
const CARLOS_PHOTO = "https://customer-assets-lqy194kg.emergentagent.net/job_0e1ba4ee-a725-40b4-9962-4ddff85eb22c/artifacts/6833b558ffd09e3c_Confident%20Seated%20Studio%20Portrait.png";
const CECILIA_PHOTO = "https://customer-assets-lqy194kg.emergentagent.net/job_0e1ba4ee-a725-40b4-9962-4ddff85eb22c/artifacts/e093752d169e508e_Calm%20Monochrome%20Studio%20Portrait.png";
const JHONNY_PHOTO = "https://customer-assets-lqy194kg.emergentagent.net/job_0e1ba4ee-a725-40b4-9962-4ddff85eb22c/artifacts/e55d055eb756ad3b_Monochrome%20Portrait%20of%20a%20Relaxed%20Man.png";
const ROSANGELICA_PHOTO = "https://customer-assets-lqy194kg.emergentagent.net/job_0e1ba4ee-a725-40b4-9962-4ddff85eb22c/artifacts/d7b25f2f888e405b_Serene%20Monochrome%20Studio%20Portrait.png";

const TeamSection = () => {
  const { t } = useLanguage();
  const members = [
    { name: "Francisco Ribadeneira", role: t.team.members.ceo, photo: FRANCISCO_PHOTO },
    { name: "Carlos Benitez", role: t.team.members.production, photo: CARLOS_PHOTO },
    { name: "Cecilia Salazar", role: t.team.members.accountManager, photo: CECILIA_PHOTO },
    { name: "Jhonny Martínez", role: t.team.members.productionAssistant, photo: JHONNY_PHOTO },
    { name: "Rosangelica Del Valle", role: t.team.members.accountExecutive, photo: ROSANGELICA_PHOTO }
  ];

  return (
    <section id="nosotros" className="py-24 md:py-32 px-6 bg-black" data-testid="team-section">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-20"
        >
          <h2 className="font-syne font-bold text-3xl sm:text-4xl md:text-5xl text-white mb-4" data-testid="team-title">
            {t.team.title}
          </h2>
          <p className="font-manrope text-white/50 text-base md:text-lg">{t.team.subtitle}</p>
        </motion.div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-8 md:gap-10">
          {members.map((member, idx) => (
            <motion.div
              key={member.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: idx * 0.08 }}
              className="flex flex-col items-center text-center group"
              data-testid={`team-member-${idx}`}
            >
              <div className="relative w-full aspect-[3/4] overflow-hidden rounded-2xl bg-white/5 mb-5 border border-white/5">
                <img
                  src={member.photo}
                  alt={member.name}
                  loading="lazy"
                  className="w-full h-full object-cover grayscale transition-all duration-700 group-hover:grayscale-0 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent pointer-events-none" />
              </div>
              <h3 className="font-syne font-semibold text-white text-base md:text-lg tracking-tight">
                {member.name}
              </h3>
              <div className="h-px w-6 bg-[#00D9C0]/60 my-2.5" />
              <p className="font-space text-white/50 text-xs md:text-sm uppercase tracking-widest">
                {member.role}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Differentiator Section
const DifferentiatorSection = () => {
  const { lang, t } = useLanguage();
  return (
    <section id="diferenciador" className="py-24 md:py-32 px-6" data-testid="differentiator-section">
      <div className="max-w-4xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="font-syne font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl mb-8 leading-tight" data-testid="differentiator-title">
            {t.differentiator.title}<br />
            <span className="text-gradient-cinematic">{t.differentiator.subtitle}</span>
          </h2>
          <p className="font-manrope text-lg md:text-xl text-white/60 max-w-3xl mx-auto leading-relaxed">
            {lang === 'es' 
              ? <>No improvisamos. Diseñamos <span className="text-white">sistemas estratégicos</span> que integran performance, inteligencia artificial y narrativa visual para generar <span className="text-white">resultados consistentes</span>.</>
              : <>We don't improvise. We design <span className="text-white">strategic systems</span> that integrate performance, artificial intelligence and visual narrative to generate <span className="text-white">consistent results</span>.</>
            }
          </p>
        </motion.div>
      </div>
    </section>
  );
};

// Contact Section with Professional Form
const ContactSection = () => {
  const { lang, t } = useLanguage();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    service: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
      
      if (response.ok) {
        setSubmitted(true);
        setFormData({ name: '', email: '', phone: '', company: '', service: '', message: '' });
      } else {
        alert(lang === 'es' ? 'Error al enviar el formulario. Intenta de nuevo.' : 'Error sending form. Please try again.');
      }
    } catch (error) {
      console.error('Error:', error);
      alert(lang === 'es' ? 'Error al enviar el formulario. Intenta de nuevo.' : 'Error sending form. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contacto" className="py-24 md:py-32 px-6" data-testid="contact-section">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="font-syne font-bold text-4xl sm:text-5xl md:text-6xl mb-4" data-testid="contact-title">
            {t.contact.title} <span className="text-gradient-cinematic">{t.contact.highlight}</span>.
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12 items-start">
          {/* Contact Buttons */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="space-y-6"
          >
            <h3 className="font-syne font-bold text-2xl mb-8">{t.contact.formSubtitle}</h3>
            
            <a 
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full btn-primary flex items-center justify-center gap-3 text-lg px-8 py-4"
              data-testid="contact-whatsapp"
            >
              <MessageCircle className="w-5 h-5" />
              {t.contact.whatsapp}
            </a>
            
            <a 
              href={INSTAGRAM_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full btn-secondary flex items-center justify-center gap-3 text-lg px-8 py-4 hover:border-pink-500 hover:text-pink-400"
              data-testid="contact-instagram"
            >
              <Instagram className="w-5 h-5" />
              {t.contact.instagram}
            </a>
          </motion.div>

          {/* Professional Contact Form */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="bg-[#0F0F0F] border border-white/10 rounded-3xl p-8"
          >
            <h3 className="font-syne font-bold text-2xl mb-2">{t.contact.formTitle}</h3>
            <p className="text-white/50 mb-8 font-manrope">{t.contact.formSubtitle}</p>

            {submitted ? (
              <div className="text-center py-12">
                <div className="w-16 h-16 bg-cyan-400/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Mail className="w-8 h-8 text-cyan-400" />
                </div>
                <p className="text-white font-syne text-xl">{lang === 'es' ? '¡Gracias por tu interés!' : 'Thank you for your interest!'}</p>
                <p className="text-white/50 mt-2">{lang === 'es' ? 'Tu solicitud ha sido enviada. Te contactaremos pronto.' : 'Your request has been sent. We will contact you soon.'}</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-5">
                <div className="grid sm:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-white/60 text-sm mb-2 font-space">{t.contact.name} *</label>
                    <input
                      type="text"
                      required
                      value={formData.name}
                      onChange={(e) => setFormData({...formData, name: e.target.value})}
                      className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white placeholder-white/30 focus:border-cyan-400 focus:outline-none transition-colors"
                      placeholder="John Doe"
                    />
                  </div>
                  <div>
                    <label className="block text-white/60 text-sm mb-2 font-space">{t.contact.emailLabel} *</label>
                    <input
                      type="email"
                      required
                      value={formData.email}
                      onChange={(e) => setFormData({...formData, email: e.target.value})}
                      className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white placeholder-white/30 focus:border-cyan-400 focus:outline-none transition-colors"
                      placeholder="john@company.com"
                    />
                  </div>
                </div>

                <div className="grid sm:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-white/60 text-sm mb-2 font-space">{t.contact.phone}</label>
                    <input
                      type="tel"
                      value={formData.phone}
                      onChange={(e) => setFormData({...formData, phone: e.target.value})}
                      className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white placeholder-white/30 focus:border-cyan-400 focus:outline-none transition-colors"
                      placeholder="+1 234 567 890"
                    />
                  </div>
                  <div>
                    <label className="block text-white/60 text-sm mb-2 font-space">{t.contact.company}</label>
                    <input
                      type="text"
                      value={formData.company}
                      onChange={(e) => setFormData({...formData, company: e.target.value})}
                      className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white placeholder-white/30 focus:border-cyan-400 focus:outline-none transition-colors"
                      placeholder="Acme Inc."
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-white/60 text-sm mb-2 font-space">{t.contact.service} *</label>
                  <select
                    required
                    value={formData.service}
                    onChange={(e) => setFormData({...formData, service: e.target.value})}
                    className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white focus:border-cyan-400 focus:outline-none transition-colors appearance-none cursor-pointer"
                  >
                    <option value="" className="bg-[#0F0F0F]">{lang === 'es' ? '-- Selecciona una opción --' : '-- Select an option --'}</option>
                    <option value="Pauta Digital" className="bg-[#0F0F0F]">{t.contact.services.digital}</option>
                    <option value="Producción Audiovisual" className="bg-[#0F0F0F]">{t.contact.services.audiovisual}</option>
                    <option value="Manejo Integral de Redes" className="bg-[#0F0F0F]">{t.contact.services.social}</option>
                    <option value="Consultoría" className="bg-[#0F0F0F]">{t.contact.services.consulting}</option>
                  </select>
                </div>

                <div>
                  <label className="block text-white/60 text-sm mb-2 font-space">{t.contact.message}</label>
                  <textarea
                    rows={4}
                    value={formData.message}
                    onChange={(e) => setFormData({...formData, message: e.target.value})}
                    className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white placeholder-white/30 focus:border-cyan-400 focus:outline-none transition-colors resize-none"
                    placeholder={lang === 'es' ? 'Cuéntanos sobre tu proyecto...' : 'Tell us about your project...'}
                  />
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-gradient-to-r from-cyan-500 to-emerald-500 text-white font-syne font-bold text-lg py-4 rounded-xl hover:opacity-90 transition-opacity disabled:opacity-50 flex items-center justify-center gap-2"
                >
                  {isSubmitting ? (
                    <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                  ) : (
                    <>
                      {t.contact.submit}
                      <span>→</span>
                    </>
                  )}
                </button>
              </form>
            )}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

// Footer
const Footer = () => {
  const { lang, t } = useLanguage();
  return (
    <footer className="py-12 px-6 border-t border-white/5" data-testid="footer">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col items-center gap-6 mb-8">
          <div className="bg-white rounded-2xl p-4">
            <img src={FXR_LOGO} alt="FXR Marketing" className="h-16 w-auto object-contain" />
          </div>
          <p className="font-space text-sm text-white/60 text-center">
            {t.footer.tagline}
          </p>
        </div>
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-6 border-t border-white/5">
          <span className="font-space text-sm text-white/40">
            Data + IA + Cinematic Growth
          </span>
          <p className="font-manrope text-sm text-white/30">
            © {new Date().getFullYear()} FXR Marketing. {lang === 'es' ? 'Todos los derechos reservados.' : 'All rights reserved.'}
          </p>
        </div>
      </div>
    </footer>
  );
};

// Main App Component
function App() {
  const [lang, setLang] = useState('es');
  const t = translations[lang];

  // Initialize Lenis smooth scroll - disabled on mobile for better performance
  useEffect(() => {
    // Skip Lenis on mobile for better performance
    if (window.innerWidth < 768) return;

    const lenis = new Lenis({
      duration: 1.0,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      direction: 'vertical',
      gestureDirection: 'vertical',
      smooth: true,
      smoothTouch: false,
      touchMultiplier: 2
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      <div className="App noise-bg min-h-screen bg-[#050505]" data-testid="app-container">
        <Navigation />
        <main>
          <HeroSection />
          <div className="section-divider" />
          <AuthoritySection />
          <div className="section-divider" />
          <PillarsSection />
          <div className="section-divider" />
          <ResultsSection />
          <div className="section-divider" />
          <PortfolioSection />
          <div className="section-divider" />
          <PortfolioVideosSection />
          <div className="section-divider" />
          <PhotographySection />
          <div className="section-divider" />
          <BrandsSection />
          <div className="section-divider" />
          <IntegrationsSection />
          <div className="section-divider" />
          <OfficialPartnersSection />
          <div className="section-divider" />
          <PresenceSection />
          <TeamSection />
          <div className="section-divider" />
          <DifferentiatorSection />
          <div className="section-divider" />
          <ContactSection />
        </main>
        <Footer />
      </div>
    </LanguageContext.Provider>
  );
}

export default App;
